/**
 * Skeleton — 로딩 상태를 나타내는 플레이스홀더 컴포넌트
 *
 * 콘텐츠가 로드되는 동안 shimmer 애니메이션으로 자리를 잡아준다.
 */

import { cn } from '../../lib/cn.js'
import styles from './Skeleton.module.css'

interface SkeletonProps {
  /** 너비. 숫자는 px, 문자열은 그대로 사용 */
  width?: string | number
  /** 높이. 숫자는 px, 문자열은 그대로 사용 */
  height?: string | number
  /** 스켈레톤 변형. 기본값 text */
  variant?: 'text' | 'circle' | 'rect'
  /** variant='text'일 때 렌더링할 줄 수 */
  lines?: number
  className?: string
}

function toPx(val: string | number | undefined): string | undefined {
  if (val === undefined) return undefined
  return typeof val === 'number' ? `${val}px` : val
}

export function Skeleton({
  width,
  height,
  variant = 'text',
  lines,
  className,
}: SkeletonProps) {
  if (variant === 'text' && lines && lines > 1) {
    return (
      <div className={cn(styles.lines, className)}>
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className={cn(styles.root, styles.text, i === lines - 1 && styles.lastLine)}
            style={{
              width: i === lines - 1 ? '60%' : toPx(width),
              height: toPx(height),
            }}
          />
        ))}
      </div>
    )
  }

  return (
    <div
      className={cn(
        styles.root,
        variant === 'text' && styles.text,
        variant === 'circle' && styles.circle,
        variant === 'rect' && styles.rect,
        className,
      )}
      style={{ width: toPx(width), height: toPx(height) }}
    />
  )
}
